import { mapGetters } from 'vuex'
import { getUploadConfig } from '@/utils/upload'
import journal from '@/api/journal'
import { settingJournalAtype } from '@/api/setting'
import { volume, vissue } from '@/api/vissue'
import special from '@/api/special'
import operation from '@/api/operation'
import Add from './add.dialog.vue'
import Detail from './detail.dialog.vue'
import AddOrg from './addOrg.dialog.vue'
import AddRef from './addRef.dialog.vue'
import AddFoun from './addFoun.dialog.vue'
import section from '@/api/section'
import article from '@/api/article'
import zip from '@/utils/zip'
import help from '@/utils/help'
import { settingCountry } from '@/api/setting'
import { editorAssign } from '@/api/editor'
import { macademic } from '@/api/macademic'
import { settingJournal } from '@/api/setting'
import { topic } from '@/api/topics'
import tipInfoDialog from '../tipInfo.dialog'
import SiteSearchGroup from '@/components/search-group'

const authorColumns = [
  {
    title: '',
    enTitle: 'Name',
    width: 230,
    dataIndex: 'name',
    slot: 'name'
  },
  {
    title: '',
    enTitle: 'Email',
    width: 200,
    dataIndex: 'email',
    slot: 'omis'
  },
  {
    title: '',
    enTitle: 'Superscript',
    width: 100,
    dataIndex: 'sup'
  },
  {
    title: '',
    enTitle: 'Actions',
    width: 100,
    dataIndex: 'actions',
    // fixed: 'right',
    slot: 'actions'
  }
]
const orgColumns = [
  {
    title: '',
    enTitle: 'Affiliation No.',
    width: 100,
    dataIndex: 'sort'
  },
  {
    title: '',
    enTitle: 'Affiliation',
    width: 300,
    dataIndex: 'name'
  },
  {
    title: '',
    enTitle: 'Country',
    width: 200,
    dataIndex: 'country'
  },
  {
    title: '',
    enTitle: 'Actions',
    width: 120,
    dataIndex: 'actions',
    slot: 'actions'
  }
]
const RefColumns = [
  {
    title: '',
    enTitle: 'No.',
    width: 50,
    dataIndex: 'sort'
  },
  {
    title: '',
    enTitle: 'Reference',
    width: 550,
    dataIndex: 'content',
    slot: 'html'
  },
  {
    title: '',
    enTitle: 'Actions',
    width: 120,
    dataIndex: 'actions',
    slot: 'actions'
  }
]
const FounColumns = [
  {
    title: '',
    enTitle: 'Funder',
    width: 450,
    dataIndex: 'name'
  },
  {
    title: '',
    enTitle: 'Grant Number',
    width: 150,
    dataIndex: 'code'
  },
  {
    title: '',
    enTitle: 'Actions',
    width: 120,
    dataIndex: 'actions',
    slot: 'actions'
  }
]
export default {
  components: {
    Add,
    AddOrg,
    AddRef,
    AddFoun,
    Detail,
    tipInfoDialog,
    SiteSearchGroup
  },
  data() {
    return {
      authorColumns,
      orgColumns,
      RefColumns,
      FounColumns,
      authorListDialog: false,
      affiliationListDialog: false,
      areferenceListDialog: false,
      afoundationListDialog: false,
      authorDetailDialog: false,
      journal: {},
      journalList: [],
      typeList: [],
      volumeList: [],
      issueList: [],
      sectionList: [],
      topicList: [],
      specialList: [],
      countryList: [],
      assignedEditorList: [],
      academicEditorList: [],
      keywordList: [],
      rules: {},
      showAuthorList: true,
      showOrgList: true,
      showRefList: true,
      showFounList: true,
      showHighlightsed: false,
      showGraphical: false,
      showDeclaration: false,
      authorEmail: '',
      isRe: false,
      params: {
        total_apc: '',
        journalId: '',
        doiUsed: true,
        oaed: true,
        displayed: false,
        academicEditor: '',
        assignedEditor: '',
        volumeCode: '',
        volumeId: '',
        issueCode: '',
        issueId: '',
        doi: '',
        submittedDate: '',
        revisedDate: '',
        acceptDate: '',
        publishedDate: '',
        authorList: [],
        affiliationList: [],
        areferenceList: [],
        afoundationList: [],
        keywords: [],
        detail: {
          highlightsed: false,
          graphicaled: false,
          declarationed: false
        },
        xmlFile: {},
        annexFile: {},
        pdfFile: {},
        supplyFileList: []
      },
      inputData: {},
      oldData: {},
      loading: false,

      // 防止闭包作用域互相影响
      getKeyword: '',
      alertDate: {},
      isVisable: false,
      oaDisable: false,
      keyword: '',
      articalQuery: {}
    }
  },
  computed: {
    ...mapGetters({
      language: 'getLanguage',
      publisherId: 'getPublisherId',
      domain: 'getDomain',
      manuscriptType: 'getManuscriptType'
    })
  },
  async mounted() {
    this.params.journalId = this.$route.query.journalId
    const id = this.$route.params.id
    if (id) {
      await this.getQuery(id)
    }
    this.getJournal()
    this.getType()
    await this.getVolumeCode()
    await this.getSection()
    this.getRules()
    this.initFun()
    help.closeAutocomplete()
  },
  methods: {
    initFun() {
      this.getKeyword = help.debounce(async val => {
        if (val.trim()) {
          this.keywordList = await article.getKeyword(val)
        }
      }, 1000)
      // this.getAssignedEditor()
      // this.getAcademicEditor()
      this.countrySearch()
      this.getSpecial(this.params.special ? this.params.special.titleText : '')
      this.getSeetingJournal()
      this.getTopic(this.params.topic ? this.params.topic.titleText : '')
    },
    async getIssue(id) {
      if (!id) {
        return
      }
      const issue = await vissue.query(id)
      // this.params.id = id
      // console.log(issue, 'iss', issue.oa, issue.oa === 'OA')
      if (issue.oa === 'OA' || issue.oa === 'NONOA') {
        this.oaDisable = true
        this.params.oaed = issue.oa === 'OA' ? true : false
      } else {
        this.oaDisable = false
      }
    },
    async getSpecial(val) {
      this.specialList = await special.getByTitle({
        journalId: this.params.journalId,
        released: true,
        limit: 20,
        title: val
      })
    },
    async countrySearch(val) {
      this.countryList = await settingCountry.getAll({
        keyword: val
      })
    },
    async getAssignedEditor(val) {
      this.assignedEditorList = await editorAssign.get({
        articleId: this.params.id,
        search: val
      })
    },
    async getAcademicEditor(val) {
      this.academicEditorList = await macademic.person({
        articleId: this.params.id,
        keyword: val
      })
    },
    async getQuery(id) {
      const res = await article.query(id)
      this.oldData = JSON.parse(JSON.stringify(res))
      res.keywords = res.keyword ? res.keyword.split(';') : []
      res.detail = res.detail || []
      res.summary = res.detail.summary
      res.typeCode = res.atype.code
      if (!res.doiUsed && res.doiUsed !== false) {
        res.doiUsed = true
      }
      res.journalId = res.journal && res.journal.id
      res.specialId = res.special ? res.special.id : ''
      res.xmlFile = res.xmlFile || {}
      res.sectionIdList = res.sectionList
        ? res.sectionList.map(e => {
            return e.id
          })
        : []
      res.annexFile = res.annexFile || {}
      res.pdfFile = res.pdfFile || {}
      res.supplyFileList = res.supplyFileList || []
      this.isRe = res.atype.type === 'RETRACTION'
      // this.params = Object.assign(this.params, res)
      this.params = res
      this.articalQuery = res.relatedArticle
      this.getIssue(res.issueId)
      this.showDeclaration =
        this.params.detail.declarationText ||
        this.params.relatedArticleId ||
        this.params.detail.relatedLinkText
          ? true
          : false
      this.showHighlightsed = this.params.detail.highlights ? true : false
      this.showGraphical =
        this.params.detail.graphical || this.params.detail.figureLegend
          ? true
          : false
    },
    async getJournal() {
      this.journalList = await journal.userGet()
      this.journalList.some(item => {
        if (item.id === this.params.journalId) {
          this.journal = item
          return true
        }
      })
    },
    async getSeetingJournal() {
      this.alertDate = await settingJournal.get({
        journalId: this.params.journalId
      })
    },
    async getType(keyword) {
      this.typeList = await settingJournalAtype.getAll({
        keyword,
        journalId: this.params.journalId
      })
    },
    onTypeChange(val) {
      this.typeList.some(item => {
        if (item.code === val) {
          this.isRe = item.type === 'RETRACTION'
          if (this.isRe) {
            this.params.oaed = false
            // this.$set(this.rules, 'retractionCode', [
            //   {
            //     required: true,
            //     message:
            //       'Associate Manuscript No.' +
            //       this.LANGUAGE[this.language].noEmpty
            //   }
            // ])
            this.$set(this.rules, 'pdfFile', [
              {
                required: true,
                message: 'PDF File' + this.LANGUAGE[this.language].noEmpty
              }
            ])
          } else {
            this.params.oaed = true
          }
        }
      })
    },
    async getByCode(val) {
      const res = await article.getByCode(val, {
        journalId: this.params.journalId
      })
      if (res) {
        await this.$confirm({
          title: 'Whether to fill in information automatically?',
          content:
            'Please confirm the operation, click OK to overwrite the content already filled in',
          type: 'success'
        }).then(async () => {
          const { title, authorList, affiliationList, detail, id } = res
          this.params = Object.assign(this.params, {
            title,
            authorList,
            affiliationList,
            retractionId: id
          })
          this.params.detail.conflict = detail.conflict
        })
      }
    },
    async getSection() {
      this.sectionList = await section.getAll({
        journalId: this.params.journalId
      })
    },
    async getTopic(val) {
      this.topicList = await topic.getAll(this.params.journalId, {
        keyword: val
      })
      if (this.params.topicId) {
        const flag = this.topicList.some(
          item => item.id === this.params.topicId
        )
        if (!flag) {
          this.params.topic = { ...this.params.topic, disabled: true }
          this.topicList.push(this.params.topic)
        }
        // console.log(flag, 'flag', this.params.topic)
      }
    },
    async getVolumeCode() {
      this.volumeList = await volume.getCode({
        journalId: this.params.journalId
      })
      if (this.params.volumeId) {
        this.getIssueCode(this.params.volumeId, true)
      }
    },
    getIssueCode(val, flag = false) {
      const arr = this.volumeList.find(item => {
        if (item.id === val) {
          return item
        }
      })
      this.issueList = arr.issueCodeList
      this.params.volumeCode = arr.code
      this.params.issueId = flag ? this.params.issueId : ''
      this.params.issueCode = flag ? this.params.issueCode : ''
    },
    onIssueCodeChange(id) {
      this.issueList.some(item => {
        if (item.id === id) {
          this.params.issueCode = item.code
          return true
        }
      })
      this.getIssue(id)
    },
    changeOA(e) {
      this.params.oaed = !e
    },
    changeDoiUser(e) {
      this.params.doiUsed = !e
    },
    changeDisplayed(e) {
      this.params.displayed = !e
    },
    async addAuthor() {
      let flag = false
      if (this.authorEmail) {
        const res = await article.getAuthor({
          email: this.authorEmail,
          journalId: this.params.journalId,
          specialId: this.params.specialId
        })
        if (res && res.id) {
          const f = this.params.authorList.some(item => {
            return item.email === res.email
          })
          if (!f) {
            res.corresponded = false
            this.params.authorList.push(res)
          } else {
            this.$message.error({
              title: 'Error',
              content: 'The author already exists, please do not add it again！'
            })
          }
        } else {
          this.$message.error({
            title: 'Error',
            content: 'The mailbox was not searched'
          })
          flag = true
        }
        this.authorEmail = ''
      } else {
        flag = true
      }
      if (flag) {
        this.inputData = {
          journalId: this.params.journalId,
          email: this.authorEmail,
          sort: this.params.authorList.length + 1
        }
        this.authorListDialog = true
      }
    },
    edit(val, index, key) {
      val.sort = index + 1
      val.journalId = this.params.journalId
      this.inputData = val
      this[key + 'Dialog'] = true
    },
    del(index, key) {
      this.params[key].splice(index, 1)
    },
    setSort(val, key) {
      val.forEach((item, index) => {
        item.sort = index + 1
      })
      this.params[key] = val
    },
    showAuthorDetail(record) {
      this.authorDetailDialog = true
      this.inputData = record
    },
    add(key) {
      this.inputData = {
        sort: this.params[key].length + 1
      }
      this[key + 'Dialog'] = true
    },
    async handleUpload(key, files) {
      let file = files[0]
      const MS = 100
      const maxSize = file.size / 1024 / 1024 < MS
      if (!maxSize) {
        this.$message.error({
          title: 'Error',
          content: this.LANGUAGE[this.language].notExceed + MS + 'MB'
        })
        if (key === 'supplyFileList') {
          this.params.supplyFileList.pop()
        }
        return false
      }

      let rightType = true
      if (key === 'xmlFile') {
        rightType = file.type === 'text/xml'
      }
      if (key === 'pdfFile') {
        rightType = file.type === 'application/pdf'
      }
      if (!rightType) {
        this.$message.error({
          title: 'Error',
          content: this.LANGUAGE[this.language].isWrongType
        })
        return false
      }

      const { doi, volumeCode, issueCode, typeCode } = this.params

      if (
        (!volumeCode || !issueCode || !doi || !typeCode) &&
        key === 'annexFile'
      ) {
        this.$message.error({
          title: 'Error',
          content: 'Please fill in Volume / Issue / DOI / Article Type  first!'
        })
        return
      }

      // xml解析
      if (key === 'xmlFile') {
        await this.parseXML(file)
      }
      const path = `journal/${
        this.journal.name
      }/${volumeCode}/${issueCode}/${doi}${
        key === 'supplyFileList' ? '/attachment' : ''
      }`

      this.loading = true

      if (key === 'annexFile') {
        const arr = []
        const pro_all = []
        files.forEach(item => {
          if (['.DS_Store', '.WeDrive'].includes(item.name)) {
            return
          }
          arr.push({
            name: item.name,
            file: item
          })
          pro_all.push(getUploadConfig(item, path, item.webkitRelativePath))
        })
        file = await zip.zipFile(arr, file.webkitRelativePath.split('/')[0])
        const reses = await Promise.all(pro_all)
        const flag = reses.some(item => {
          if (item.includes('err:')) {
            this.$message.error({
              title: 'Error',
              content: this.LANGUAGE[this.language].uploadFileFail
            })
            return true
          }
        })
        if (flag) {
          return false
        }
      }
      const url = await getUploadConfig(file, path)
      this.loading = false

      if (url.includes('err:')) {
        this.$message.error({
          title: 'Error',
          content: this.LANGUAGE[this.language].uploadFileFail
        })
        return false
      }

      if (key === 'supplyFileList') {
        this.params.supplyFileList[this.params.supplyFileList.length - 1] = {
          path: url,
          name: file.name
        }
        // this.params.supplyFileList.push({
        //   path: url,
        //   name: file.name
        // })
      } else if (key === 'graphical') {
        this.params.detail.graphicalName = file.name
        this.$set(this.params.detail, key, url)
      } else {
        this.$set(this.params, key, {
          path: url,
          name: file.name,
          size: file.size
        })
      }
    },

    async parseXML(file) {
      const formData = new FormData()
      formData.append('file', file)
      formData.append('journalId', this.params.journalId)
      formData.append('doi', this.params.doi)
      formData.append('typeCode', this.params.typeCode)
      const res = await article.parseXML(formData)
      if (res) {
        await this.$confirm({
          title:
            'Whether to parse the corresponding data according to the uploaded xml?',
          content:
            'Please confirm the operation, click OK to overwrite the content already filled in',
          type: 'success'
        }).then(async () => {
          // console.log(this.oldData, 'oldData', this.params)
          res.typeCode = res.atype.code
          res.summary = res.detail.summary
          res.keywords = res.keyword ? res.keyword.split(';') : []
          res.detail.authorComment = ''
          res.detail.highlightsed =
            this.oldData &&
            this.oldData.detail &&
            this.oldData.detail.highlightsed
              ? this.oldData.detail.highlightsed
              : false
          res.detail.graphicaled =
            this.oldData &&
            this.oldData.detail &&
            this.oldData.detail.graphicaled
              ? this.oldData.detail.graphicaled
              : false
          res.detail.declarationed =
            this.oldData &&
            this.oldData.detail &&
            this.oldData.detail.declarationed
              ? this.oldData.detail.declarationed
              : false
          res.detail.declarationText =
            this.oldData &&
            this.oldData.detail &&
            this.oldData.detail.declarationText
              ? this.oldData.detail.declarationText
              : ''
          res.detail.figureLegend =
            this.oldData &&
            this.oldData.detail &&
            this.oldData.detail.figureLegend
              ? this.oldData.detail.figureLegend
              : ''
          res.detail.graphical =
            this.oldData && this.oldData.detail && this.oldData.detail.graphical
              ? this.oldData.detail.graphical
              : ''
          res.detail.graphicalName =
            this.oldData &&
            this.oldData.detail &&
            this.oldData.detail.graphicalName
              ? this.oldData.detail.graphicalName
              : ''
          res.detail.highlights =
            this.oldData &&
            this.oldData.detail &&
            this.oldData.detail.highlights
              ? this.oldData.detail.highlights
              : ''
          res.detail.relatedLinkText =
            this.oldData &&
            this.oldData.detail &&
            this.oldData.detail.relatedLinkText
              ? this.oldData.detail.relatedLinkText
              : ''
          res.authorNoteList.forEach(item => {
            res.detail.authorComment += item.content
          })
          delete res.code
          this.params = Object.assign(this.params, res)
          this.getVolumeCode()
        })
      }
    },

    delOtherFile(index) {
      this.params.supplyFileList.splice(index, 1)
    },

    delFile(key) {
      this.params[key] = {}
    },

    goToPage(val) {
      help.download(`${this.domain}/${val.path}`, val.name)
    },

    confirm(val, key) {
      if (val.email) {
        const flag = this.params.authorList.some((item, index) => {
          if (
            index !== val.sort - 1 &&
            item.email &&
            item.email.toLowerCase() === val.email.toLowerCase()
          ) {
            return true
          }
        })
        if (flag) {
          this.$message.error({
            title: 'Error',
            content: 'The author already exists, please do not add it again！'
          })
          return
        }
      }
      if (key === 'afoundationList') {
        const flag = this.params.afoundationList.some((item, index) => {
          if (index !== val.sort - 1 && item.code && item.code === val.code) {
            return true
          }
        })
        if (flag) {
          this.$message.error({
            title: 'Error',
            content:
              'The foundation Number already exists, please do not add it again！'
          })
          return
        }
      }
      this[key + 'Dialog'] = false
      this.$set(this.params[key], val.sort - 1, val)
    },

    cancel(key) {
      this[key + 'Dialog'] = false
      this.isVisable = false
    },

    async bind() {
      if (!this.keyword) {
        return
      }
      const res = await article.related({
        keyword: this.keyword
      })
      if (!res) {
        this.$message.error({
          title: 'Error',
          content: 'Article not found!'
        })
        return
      }
      this.$message.success({
        title: 'Success',
        content: 'The article can be bound. Effective after saving the article!'
      })
      this.articalQuery = res
      this.params.relatedArticleId = res && res.id ? res.id : ''
    },
    linkto() {
      const journalIds = this.journalList.map(item => item.id)
      // console.log(
      //   journalIds,
      //   this.articalQuery.journalId,
      //   journalIds.includes(this.articalQuery.journalId)
      // )
      if (!journalIds.includes(this.articalQuery.journalId)) {
        this.$message.error({
          title: 'Error',
          content: 'Permission denied!'
        })
        return
      }
      let link = `/publishing/publication/${this.articalQuery.id}?journalId=${this.articalQuery.journalId}`
      window.open(link)
    },
    handleClear() {
      this.articalQuery = {}
      this.keyword = ''
      this.params.relatedArticleId = ''
    },
    async submit(handle = '') {
      if (this.loading) {
        this.$message.warning({
          title: 'Warning',
          content: 'Please wait patiently for the file upload to complete'
        })
        return
      }
      const flag = this.$refs['article-add-form'].validate()
      if (!flag) {
        return
      }
      if (!this.params.authorList.length) {
        this.$message.error({
          title: 'Error',
          content: 'Author' + this.LANGUAGE[this.language].noEmpty
        })
        return
      }
      if (!this.params.affiliationList.length) {
        this.$message.error({
          title: 'Error',
          content: 'Affiliation' + this.LANGUAGE[this.language].noEmpty
        })
        return
      }
      this.params.detail.summary = this.params.summary
      this.params.keyword = this.params.keywords
        ? this.params.keywords.join(';')
        : ''
      this.params.status = handle || this.params.status || 'UNPUBLISHED'
      // if (!this.params.xmlFile.path) {
      //   delete this.params.xmlFile
      // }
      // if (!this.params.annexFile.path) {
      //   delete this.params.annexFile
      // }
      // if (!this.params.pdfFile.path) {
      //   delete this.params.pdfFile
      // }
      if (this.params.keyword.length > 2048) {
        this.$message.error({
          title: 'Error',
          content: 'The keyword exceeds the maximum length (2048 words)!'
        })
        return
      }
      if (
        this.params.detail &&
        this.params.detail.declarationText &&
        this.params.detail.declarationText.length > 256
      ) {
        this.$message.error({
          title: 'Error',
          content: 'Text length must not be more than 256 digits!'
        })
        return
      }
      if (
        this.params.detail &&
        this.params.detail.relatedLinkText &&
        this.params.detail.relatedLinkText.length > 512
      ) {
        this.$message.error({
          title: 'Error',
          content: 'related Link Text length must not be more than 512 digits!'
        })
        return
      }
      if (this.keyword && !this.articalQuery) {
        this.$message.error({
          title: 'Error',
          content: 'The associated article id is incorrect!'
        })
        return
      }
      let flag1 = false,
        flag2 = false,
        flag3 = false
      if (this.params.revisedDate && this.params.submittedDate) {
        flag1 =
          this.$moment(this.params.revisedDate).diff(
            this.$moment(this.params.submittedDate),
            'days'
          ) < this.alertDate.RECEIVED_REVISED_DATE
      }
      if (this.params.acceptDate && this.params.revisedDate) {
        flag2 =
          this.$moment(this.params.acceptDate).diff(
            this.$moment(this.params.revisedDate),
            'days'
          ) < this.alertDate.REVISED_ACCEPT_DATE
      }

      if (this.params.publishedDate && this.params.acceptDate) {
        flag3 =
          this.$moment(this.params.publishedDate).diff(
            this.$moment(this.params.acceptDate),
            'days'
          ) < this.alertDate.ACCEPT_PUBLISHED_DATE
      }
      if (flag1 || flag2 || flag3) {
        this.inputData = this.params
        this.inputData.__status = handle
        this.inputData.__flag1 = flag1
        this.inputData.__flag2 = flag2
        this.inputData.__flag3 = flag3
        this.isVisable = true
        return
      }
      this.publishAfter(handle)
      // return
    },
    async publishAfter(handle) {
      if (this.params.id) {
        // console.log(this.params, '参数')
        const res = await article.edit(this.params.id, this.params)
        this.oldData.authorList.forEach(item => {
          delete item.updateTime
        })
        res.authorList.forEach(item => {
          delete item.updateTime
        })
        const keys = {
          atype: `【Article Type】: Change from 【${this.oldData.atype.name}】 to 【${res.atype.name}】;`,
          oaed: `【OA】: Change from 【${
            this.oldData.oaed ? 'Yes' : 'No'
          }】 to 【${res.oaed ? 'Yes' : 'No'}】;`,
          doi: `【DOI】: Change from 【${this.oldData.doi}】 to 【${res.doi}】;`,
          doiUsed: `【DOI Show】: Change from 【${
            this.oldData.doiUsed ? 'Yes' : 'No'
          }】 to 【${res.doiUsed ? 'Yes' : 'No'}】;`,
          pii: `【Pii.】: Change from 【${this.oldData.pii}】 to 【${res.pii}】;`,
          volumeCode: `【Volume 】: Change from 【${this.oldData.volumeCode}】 to 【${res.volumeCode}】;`,
          issueCode: `【Issue】: Change from 【${this.oldData.issueCode}】 to 【${res.issueCode}】;`,
          startPage: `【Start Page Number 】: Change from 【${this.oldData.startPage}】 to 【${res.startPage}】;`,
          endPage: `【End Page Number】: Change from 【${this.oldData.endPage}】 to 【${res.endPage}】;`,
          sort: `【Sort】: Change from 【${this.oldData.sort}】 to 【${res.sort}】;`,
          submittedDate: `【Received Date】:Change from 【${this.oldData
            .submittedDate &&
            this.$moment(this.oldData.submittedDate).format(
              'DD / MM / YYYY'
            )}】 to 【${res.submittedDate &&
            this.$moment(res.submittedDate).format('DD / MM / YYYY')}】;`,
          revisedDate: `【Revised Date】: Change from 【${this.oldData
            .revisedDate &&
            this.$moment(this.oldData.revisedDate).format(
              'DD / MM / YYYY'
            )}】 to 【${res.revisedDate &&
            this.$moment(res.revisedDate).format('DD / MM / YYYY')}】;`,
          acceptDate: `【Accept Date】: Change from 【${this.oldData
            .acceptDate &&
            this.$moment(this.oldData.acceptDate).format(
              'DD / MM / YYYY'
            )}】 to 【${res.acceptDate &&
            this.$moment(res.acceptDate).format('DD / MM / YYYY')}】;`,
          publishedDate: `【Published Date】: Change from 【${this.oldData
            .publishedDate &&
            this.$moment(this.oldData.publishedDate).format(
              'DD / MM / YYYY'
            )}】 to 【${res.publishedDate &&
            this.$moment(res.publishedDate).format('DD / MM / YYYY')}】;`,
          sectionList: `【Section】: Changed;`,
          specialId: `【Special Issue】: Changed;`,
          title: `【Title】: Changed;`,
          authorList: `【Authors】:  Changed;`,
          affiliationList: `【Affiliations】: Changed;`,
          keyword: `【Keywords】: Changed;`,
          afoundationList: `【Funding】: Changed;`,
          copyrightHolder: `【Copyright】: Change from 【${this.oldData.copyrightHolder}】 to 【${res.copyrightHolder}】;`,
          xmlFile: `【XML File】: Changed;`,
          annexFile: `【XML Attachment】: Changed;`,
          pdfFile: `【PDF File】: Changed;`,
          supplyFileList: `【Other Attachment】: Changed;`
        }
        let detail = ``
        Object.keys(keys).forEach(key => {
          if (JSON.stringify(this.oldData[key]) != JSON.stringify(res[key])) {
            detail += keys[key] + '<br/>'
          }
        })
        if (detail) {
          await operation.add({
            authorityCode: 'WEBSITE.PUBLISHING.EDIT',
            type: 'EDIT',
            info: `Edit The Article: ${res.doi}`,
            detail
          })
        }
        this.$message.success({
          title: 'Success',
          content: `The Article has been ${handle.toLowerCase() || 'saved'}!`
        })
        this.isVisable = false
        const id = this.$route.params.id
        if (id) {
          await this.getQuery(id)
        }
      } else {
        const res = await article.add(this.params)
        await operation.add({
          authorityCode: 'WEBSITE.PUBLISHING.ADD',
          type: 'ADD',
          info: `Add New Article: ${res.doi}`,
          detail: `【Journal】: ${res.journal.name}<br/>
        【Article Type】: ${res.atype.name}<br/>
        【DOI】: ${res.doi}<br/>
        【Volume】: ${res.volumeCode}<br/>
        【Issue】: ${res.issueCode}<br/> `
        })
        if (handle) {
          await operation.add({
            authorityCode: 'WEBSITE.PUBLISHING.PUBLISH',
            type: 'PUBLISH',
            info: `Publish/Unpublish: ${res.doi}`,
            detail: `Change from 【Unpublish】 to 【Publish】`
          })
        }
        this.$message.success({
          title: 'Success',
          content: `The Article has been ${handle.toLowerCase() || 'saved'}!`
        })
        this.$router.back(-1)
        return
      } // this.$router.back(-1)
    },
    preview() {},
    async handleBlur(val) {
      if (val) {
        await article.checkTitle(val)
      }
    },
    getRules() {
      this.rules = {
        journalId: [
          {
            required: true,
            message: 'Journal' + this.LANGUAGE[this.language].noEmpty
          }
        ],
        typeCode: [
          {
            required: true,
            message: 'Article Type' + this.LANGUAGE[this.language].noEmpty
          }
        ],
        doi: [
          {
            required: true,
            message: 'DOI' + this.LANGUAGE[this.language].noEmpty
          }
        ],
        volumeId: [
          {
            required: true,
            message: 'Volume' + this.LANGUAGE[this.language].noEmpty
          }
        ],
        issueId: [
          {
            required: true,
            message: 'Issue' + this.LANGUAGE[this.language].noEmpty
          }
        ],
        startPage: [
          {
            required: true,
            message: 'Start Page Number' + this.LANGUAGE[this.language].noEmpty
          },
          {
            min: 0,
            message: 'Please enter a positive integer'
          }
        ],
        title: [
          {
            required: true,
            message: 'Title' + this.LANGUAGE[this.language].noEmpty
          }
        ],
        totalApc: [
          {
            min: 0,
            message: 'The Total APC cannot be less than 0!'
          }
        ],
        declarationText: [
          {
            max: 256,
            message: `Text length must not be more than 256 digits`
          }
        ],
        // summary: [
        //   {
        //     required: true,
        //     message: 'Abstract' + this.LANGUAGE[this.language].noEmpty
        //   }
        // ]
        relatedLinkText: [
          {
            type: 'website',
            message: this.LANGUAGE[this.language].enterCorrent + 'Link Text'
          },
          {
            max: 512,
            message: `Link Text length must not be more than 512 digits`
          }
        ]
      }
      if (this.params.id) {
        this.rules.pii = [
          {
            required: true,
            message: 'Pii.' + this.LANGUAGE[this.language].noEmpty
          }
        ]
        this.rules.code = [
          {
            required: true,
            message: 'Manuscript No.' + this.LANGUAGE[this.language].noEmpty
          }
        ]
      }
    }
  }
}
